<template>
  <span
    class="tw:inline-flex tw:items-center tw:justify-center tw:gap-1 tw:whitespace-nowrap tw:rounded-full tw:border tw:border-solid tw:px-[9px] tw:py-px tw:text-12 tw:font-medium"
    :class="toneClass">
    <span v-if="dot" class="tw:relative tw:inline-block tw:size-1.5 tw:shrink-0 tw:rounded-full tw:bg-current" />
    <slot />
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Props {
  /** neutral is an unfilled outline */
  tone?: 'neutral' | 'primary' | 'success' | 'danger' | 'warning';
  /** a small leading dot, same colour as the text */
  dot?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  tone: 'neutral',
  dot: false,
});

const toneClass = computed(() => {
  const tones = {
    neutral: 'tw:border-body tw:text-body',
    primary: 'tw:bg-blue-50 tw:border-blue-200 tw:text-blue-500',
    success: 'tw:bg-success-50 tw:border-success-200 tw:text-success-700',
    danger: 'tw:bg-red-50 tw:border-red-200 tw:text-red-600',
    warning: 'tw:bg-orange-50 tw:border-orange-200 tw:text-orange-600',
  };

  return tones[props.tone];
});
</script>
